import { SlotRepository } from '../Repositories/SlotRepository';
import { CreateSlotDTO, Slot } from '../../Model/Slot';
import { User } from '../../../User/Model/User';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';
import { minStartDateYmdForLimitedPartnerCreate } from './Utils/DateUtil';

export interface BatchCreateSlotRequest {
  count: number;
  slots: CreateSlotDTO[];
}

export class BatchCreateSlotUseCase {
  constructor(private repo: SlotRepository) {}

  async execute(request: BatchCreateSlotRequest, me: User): Promise<Slot[]> {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(me, '발주')) {
      throw new Error(getRestrictionMessage('생성', me));
    }

    const isLimitedAdmin = me.grade === 'ADMIN' && Boolean(me.is_limited_partner_admin);
    if (isLimitedAdmin) {
      const minStart = minStartDateYmdForLimitedPartnerCreate();
      const bad = request.slots.find(s => s.start_date && s.start_date < minStart);
      if (bad) {
        throw new Error(
          `제한형 관리자는 시작일을 ${minStart} 이후(내일)부터만 지정할 수 있습니다.`,
        );
      }
    }

    return this.repo.batchCreate(request);
  }
}
